var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.001,
    height: 41.039,
    viewBox: "0 0 41.001 41.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2239",
    "data-name": "Group 2239",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M115.926,99.627a2.816,2.816,0,0,1-2.849,2.806H90.538a2.816,2.816,0,0,1-2.849-2.806V77.008A2.843,2.843,0,0,1,90.538,74.2h11.521l3.645-3.644H90.537A6.5,6.5,0,0,0,84,77.008V99.627a6.508,6.508,0,0,0,6.535,6.493h22.581a6.508,6.508,0,0,0,6.535-6.493v-15.2l-3.645,3.644V99.627Z",
    transform: "translate(-84.002 -66.08)",
    fill: "#4b4b4b",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M244.811,20.295,239.4,14.931A3.132,3.132,0,0,0,237.231,14a3.013,3.013,0,0,0-2.172.886L215.111,34.834a3.065,3.065,0,0,0-.887,1.995l-.355,5.718a3.168,3.168,0,0,0,.886,2.394,3.087,3.087,0,0,0,2.172.886h.177l5.763-.354a3.066,3.066,0,0,0,1.995-.886l19.9-19.9a3.087,3.087,0,0,0,.887-2.172,2.906,2.906,0,0,0-.842-2.216Zm-12.722,3.059,4.3,4.3-9.974,9.929-4.3-4.3ZM222.337,41.66l-4.566.266.266-4.566,1.285-1.285,4.3,4.3Zm16.756-16.8-4.255-4.255,2.394-2.394,4.3,4.3Z",
    transform: "translate(-205.657 -14)",
    fill: "#4b4b4b",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.02a6f7b5e2cea572c3eb695c121b9644.svg";
export { ForwardRef as ReactComponent };